import React, { useState } from 'react';
import '../../../component-styles/LibraryModal.css';
import API_BASE from '../../../utils/api.js';
import notify from '../../../utils/notify';

export default function AddSectionForm({ onClose, onSave, projectId = null }) {
  const apiUrl = API_BASE;
  const userId = localStorage.getItem('userId');

  const [form, setForm] = useState({ name: '' });
  const [loading, setLoading] = useState(false);

  function handleChange(e) {
    setForm({ name: e.target.value });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);

    const endpoint = projectId
      ? `${apiUrl}/api/library/${userId}/${projectId}/sections`
      : `${apiUrl}/api/library/${userId}/sections`;

    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });

      const data = await res.json();
      if (res.ok) {
        onSave({ ...data, name: form.name });
        onClose();
      } else {
        notify(data.error || 'Failed to save section.');
      }
    } catch (err) {
      console.error('Error saving section:', err);
      notify('Error saving section.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="library-modal-overlay" onClick={onClose}>
      <div className="library-modal-content" onClick={(e) => e.stopPropagation()}>
        <h3 className="library-modal-title">Add Section</h3>

        <form onSubmit={handleSubmit} className="library-modal-form">
          <input
            name="name"
            placeholder="Section Name"
            value={form.name}
            onChange={handleChange}
            required
          />

          <div className="library-modal-actions">
            <button type="button" onClick={onClose} className="library-modal-cancel-btn">
              Cancel
            </button>

            <button type="submit" disabled={loading} className="library-modal-save-btn">
              {loading ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
